/**
 * API endpoint for public programs list.
 */
export const PROGRAMS_API = "/programs/";

/**
 * API endpoint for authenticated user's programs.
 * For detail, append program ID: `/programs/user/{id}/`
 */
export const USER_PROGRAMS_API = "/programs/user/";

/**
 * Default page size for programs list.
 */
export const PROGRAMS_PAGE_SIZE = 20;
